import { useNavigate } from "react-router-dom";


export default function HomeFooter() {
const navigate = useNavigate();

  return (
    <footer className="home-footer">



      <div className="home-footer-inner">
        <div className="home-logo" onClick={() => navigate("/")} style={{ fontSize: 15, cursor:"pointer" }}>
            <img src="/creatorcomment-logo.png" alt="CreatorComment Logo" className="logo-img" />
        </div>
        <div className="footer-links">
          {/* <a href="/#features">Features</a>
          <a href="/#pricing">Pricing</a>
          <a href="/#testimonials">Reviews</a> */}

          <a href="/terms-of-service">Terms of service</a>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/cancellation">Refund Policy</a>
        </div>
        <div className="footer-copy">© 2026 CreatorComment. Built for creators.</div>
      </div>
    </footer>
  );
}